module.exports = __webpack_public_path__ + "img/app_icon_28.cb334fbc.png";